<template>
  <div id="sponsor-category-ad-or-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie   v-if="loading == 'updateScreenLoading' && form == null" key="create-loading"  />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.titleMsgCat") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.imageSize") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.imageSizeMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div style="width:98%">
                  <el-slider :min="5" :max="50" v-model="form.logoScale"></el-slider>
                </div>
                <span class="error">{{ $errorMessage("logoScale", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2">
            <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo },
  name: "SponsorCategoryAddUpdate",
  props: ["id"],
  data() {
    return {
      form: null,
      loading: false,
      timeout: null,
      settingsDock: false,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
    };
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMeCategory", this.form.id);

      this.$emit("closeDialog");
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateSponsorCategory", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getSponsors");
        }
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data;
      }
    },
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);

    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getSponsorCategory", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          title: null,
          orderNO: 99,
          logoScale: 25,
          isActive: true,
        };
        this.loading = false;
      }, 500);
    }
  },
};
</script>
<style lang="less">
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SponsorCategoryAddUpdate.vue